export const THEMES = {
  LIGHT: "LIGHT",
};
